/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem,
    ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItemFromJSON,
    ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItemFromJSONTyped,
    ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItemToJSON,
    ControlcenterMelcoControlCenterModelsDigitizingOrderDetail,
    ControlcenterMelcoControlCenterModelsDigitizingOrderDetailFromJSON,
    ControlcenterMelcoControlCenterModelsDigitizingOrderDetailFromJSONTyped,
    ControlcenterMelcoControlCenterModelsDigitizingOrderDetailToJSON,
    ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem,
    ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItemFromJSON,
    ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItemFromJSONTyped,
    ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail
 */
export interface ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail {
    /**
     * 
     * @type {ControlcenterMelcoControlCenterModelsDigitizingOrderDetail}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail
     */
    order?: ControlcenterMelcoControlCenterModelsDigitizingOrderDetail;
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem>}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail
     */
    alerts?: Array<ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItem> | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem>}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail
     */
    history?: Array<ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem> | null;
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetailFromJSON(json: any): ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail {
    return ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetailFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'order': !exists(json, 'order') ? undefined : ControlcenterMelcoControlCenterModelsDigitizingOrderDetailFromJSON(json['order']),
        'alerts': !exists(json, 'alerts') ? undefined : (json['alerts'] === null ? null : (json['alerts'] as Array<any>).map(ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItemFromJSON)),
        'history': !exists(json, 'history') ? undefined : (json['history'] === null ? null : (json['history'] as Array<any>).map(ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItemFromJSON)),
    };
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetailToJSON(value?: ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'order': ControlcenterMelcoControlCenterModelsDigitizingOrderDetailToJSON(value.order),
        'alerts': value.alerts === undefined ? undefined : (value.alerts === null ? null : (value.alerts as Array<any>).map(ControlcenterMelcoControlCenterModelsDigitizingOrderAlertItemToJSON)),
        'history': value.history === undefined ? undefined : (value.history === null ? null : (value.history as Array<any>).map(ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItemToJSON)),
    };
}


